import ReactDOM from 'react-dom';
import routes from './Router';
import './index.css';


ReactDOM.render(
  routes,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/